// extracted by mini-css-extract-plugin
export default {"mobileEditorXToolbar":"zhTMTA","button":"BlMAh9"};